export class VideoModal {
  constructor() {
    this.closeModal = this.closeModal.bind(this);
    const hasModal = document.querySelector('.video-modal--content');
    if (!hasModal) {
      //Creates background for video modal
      this.videoModalBG = document.createElement('div');
      this.videoModalBG.setAttribute('class', 'video-modal--bg');
      document.body.appendChild(this.videoModalBG);

      //Creates video modal contents
      this.videoModal = document.createElement('div');
      this.videoModalClose = document.createElement('button');
      const closeText = document.createTextNode('Close');
      this.videoModal.setAttribute('class', 'video-modal--content');
      this.videoModalClose.setAttribute('class', 'video-modal--close');
      this.videoModalClose.appendChild(closeText);
      this.videoModal.appendChild(this.videoModalClose);
      document.body.appendChild(this.videoModal);

      //Adds click event listeners to close the modal
      this.videoModalClose.addEventListener('click', this.closeModal);
      this.videoModalBG.addEventListener('click', this.closeModal);
    } else {
      this.videoModalBG = document.querySelector('.video-modal--bg');
      this.videoModal = document.querySelector('.video-modal--content');
      this.videoModalClose = document.querySelector('.video-modal--close');
    }
  }

  closeModal(e) {
    e.preventDefault();
    this.videoModalBG.classList.remove('open');
    this.videoModal.classList.remove('open');
    this.videoModal.removeChild(this.videoModal.childNodes[1]);
  }

  init(videos) {
    const self = this;
    videos.forEach((video) => {
      video.addEventListener('click', function (e) {
        e.preventDefault();
        var regExp =
          /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        var url = e.currentTarget.attributes['data-video-url'].value;
        var match = url.match(regExp);
        var videoIframe = document.createElement('iframe');
        videoIframe.setAttribute(
          'src',
          `https://youtube.com/embed/${match[7]}`
        );

        self.videoModal.appendChild(videoIframe);
        self.videoModalBG.classList.add('open');
        self.videoModal.classList.add('open');
        self.videoModalClose.focus();
      });
    });
  }
}
